<template>
  <div class="flex flex-col items-center">
    <img src="/img/algo-no-data.png" class="w-[80px]" />
    <span class="login-label mt-[8px]">No data found.</span>
  </div>
</template>
